import { render, staticRenderFns } from "./EdgeFinishMenu.vue?vue&type=template&id=1b164771&scoped=true"
import script from "./EdgeFinishMenu.vue?vue&type=script&lang=js"
export * from "./EdgeFinishMenu.vue?vue&type=script&lang=js"
import style0 from "./EdgeFinishMenu.vue?vue&type=style&index=0&id=1b164771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b164771",
  null
  
)

export default component.exports